import { render, staticRenderFns } from "./ModalRecoveryInvoices.vue?vue&type=template&id=06fa2880&scoped=true&"
import script from "./ModalRecoveryInvoices.vue?vue&type=script&lang=js&"
export * from "./ModalRecoveryInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecoveryInvoices.vue?vue&type=style&index=0&id=06fa2880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fa2880",
  null
  
)

export default component.exports